import { render, staticRenderFns } from "./Carrello.vue?vue&type=template&id=27cabb63&"
import script from "./Carrello.vue?vue&type=script&lang=js&"
export * from "./Carrello.vue?vue&type=script&lang=js&"
import style0 from "./Carrello.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports